import { FAVOURITE_LIST_RECEIVE } from '../bevegoConstants';

export const favouriteList = (
    state = { 
        quantity: 0,
        orderTotal: 0,
        showInfo: false,
        orderRows:[]
    },
    action
    ) => {
        switch (action.type) {
            case FAVOURITE_LIST_RECEIVE:
                return {
                    ...state,
                    ...action.payload,
                };
            default:
                return state;
        }
    };
    